export const swapCategoryName = (difficultLevel, impactLevel) => {
  if (difficultLevel === 'EASY' && impactLevel === 'MAJOR') return 'Sweet Spots'
  if (difficultLevel === 'EASY' && impactLevel === 'MINOR') return 'Why Nots'
  if (difficultLevel === 'HARD' && impactLevel === 'MAJOR') return 'Challenges'
  if (difficultLevel === 'HARD' && impactLevel === 'MINOR')
    return 'Maybe Laters'
  return ''
}

export const swapStatusName = status => {
  if (status === 'NEW') return 'identified'
  if (status === 'IN_PROGRESS') return 'in progress'
  if (status === 'DONE') return 'claimed'
  if (status === 'REJECTED') return 'rejected'
  return ''
}
